import styled from "styled-components";
import {CssRule} from "../../../themes/architecture/css-helpers/css-rule";

export const FreeToPlayClickBox = styled.div`
    position: fixed;
    cursor: pointer;
    z-index: 5;
    bottom: 0;
    right: 0;
    width: 150px;
    height: 123px;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 130px;
        height: 106px;
    } 
    
    ${CssRule.For.hybrid.not.miniOrbit.build()} & {
        bottom: calc(env(safe-area-inset-bottom) + 47px);
   }
`